import { render } from "./OrderCustomFieldsEditPage.vue?vue&type=template&id=61153b76"
import script from "./OrderCustomFieldsEditPage.vue?vue&type=script&lang=js"
export * from "./OrderCustomFieldsEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__